//@ts-check
import Axios from 'axios';
import { API_BASE, STATUS_FAILURE_ILLEGAL_REQUEST, STATUS_FAILURE_IDPASSWORD, STATUS_FAILURE_NOT_AUTHORIZED_DEMO, STATUS_ERROR_INTERNAL, STATUS_SUCCESS, STATUS_FAILURE_NO_USER, STATUS_FAILURE_NO_SHOP, STATUS_FAILURE_CTR_POINT, STATUS_FAILURE_NO_OWNER, STATUS_FAILURE_NO_TARGET } from '@/common/constants';
import { openFailedDialog } from '@/common/components/kf-dialog';

const formatBody = (data) => {
  if (!data) {
    return data;
  }

  if (data instanceof FormData || data instanceof URLSearchParams) {
    return data;
  }

  if (typeof data === 'string') {
    return data;
  }

  const params = new URLSearchParams();
  Object.keys(data).forEach(key => params.append(key, data[key]));
  return params.toString();
};

export const errorHandler = (e) => {
  switch (e.status) {
    case STATUS_FAILURE_ILLEGAL_REQUEST:
      return openFailedDialog('不正なリクエストです。');

    case STATUS_FAILURE_NOT_AUTHORIZED_DEMO:
      return openFailedDialog('デモ版では更新を伴う操作はできません。');

    case STATUS_ERROR_INTERNAL:
      return openFailedDialog('サーバエラーです。');

    case STATUS_FAILURE_NO_USER:
      return openFailedDialog('電話番号が登録されておりません。');

    case STATUS_FAILURE_NO_SHOP:
      return openFailedDialog('指定した店舗が無効、もしくは存在しません。');

    case STATUS_FAILURE_CTR_POINT:
      return openFailedDialog('店舗のポイント機能が有効ではありません。');

    case STATUS_FAILURE_NO_TARGET:
      return openFailedDialog('店舗のポイント機能が設定されておりません。');

    case STATUS_FAILURE_NO_OWNER:
      return openFailedDialog('オーナーが存在しません。');

    case STATUS_FAILURE_IDPASSWORD:
      return openFailedDialog('パスワードが正しくありません。');

    default:
      console.error(e);
      if (e.status != null) {
        return openFailedDialog(`エラーが発生しました(エラーコード：${e.status})`);
      } else if (e.response) {
        return openFailedDialog(`エラーが発生しました(エラーコード：${e.response.status})`);
      } else if (e.message === 'Network Error') {
        return openFailedDialog('ネットワークエラーが発生しました。ページを再度読み込んでください。');
      } else {
        return openFailedDialog(`エラーが発生しました。\n ${e.message || ''}`);
      }
  }
};

export const ajaxPost = (path, body) => {
  return new Promise((resolve, reject) => {
    Axios.post(path, formatBody(body), {
      withCredentials: true,
      baseURL: `${API_BASE}/user`,
      timeout: 60 * 1000 * 3,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
      .then(({ data }) => {
        if (data.status == STATUS_SUCCESS) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
};